import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "main-content type4" };
const _hoisted_2 = { class: "content-wrapper" };
const _hoisted_3 = { class: "mt-2 radio-wrapper" };
import { computed, onMounted, onUnmounted, ref, } from 'vue';
import { i18n } from '@/locales';
import { useRoute, useRouter, } from 'vue-router';
import { createMemberCompanyInquiryFormRule } from '@/form/form-rules/memberCompanyInquiry';
import { autoLcMemberCompanyInquiry } from '@/locales/ko/views/member_company_inquiry';
import vuexStore from '@/vuex-store';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { getFormValueForPinia, setFormValueForPinia, } from '@/utils/form';
import { alertActionType } from '@/vuex-store/alert/actions';
import { pStore } from '@/pinia';
import { storeToRefs } from 'pinia';
import { routeName } from '@/constants/routeName';
import { objDeepCompare } from '@/utils/object';
import { postFindTypeCategoryItem, radioOptions, } from '@/constants/memberCompanyInquiry/memberCompanyInquiryList';
import InputRow from '@/components/Form/InputRow.vue';
import CardSection from '@/components/Common/CardSection.vue';
import BoardFooter from '@/components/Common/BoardFooter.vue';
import SubController from './SubController.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        // page: 회원사 업무처리 신규 등록, 수정
        const lc = autoLcMemberCompanyInquiry();
        const formRule = createMemberCompanyInquiryFormRule();
        const route = useRoute();
        const router = useRouter();
        const pMemberCompanyInquiry = pStore.piniaMemberCompanyInquiry;
        const { formData, originFormData, templates, itemDetail, } = storeToRefs(pMemberCompanyInquiry);
        const getFormValue = (key) => getFormValueForPinia(formData, key);
        const setFormValue = (key, value) => setFormValueForPinia(formData, key, value);
        const confirm = (payload) => vuexStore.dispatch(alertActionType.confirm, payload);
        const formRef = ref(null);
        const pageId = route.params.itemId;
        const isCreatePage = route.name === routeName.MEMBER_COMPANY_INQUIRY_CREATE;
        const isEditPage = route.name === routeName.MEMBER_COMPANY_INQUIRY_EDIT;
        const submitButtonText = computed(() => '완료');
        // 게시물 구분 초기값
        const selectedPostCategory = ref(postFindTypeCategoryItem[0]?.key || '');
        const selectedRadioOption = ref('');
        /**
         * 객체 채크
         * @param routeData
         */
        const checkFormData = async (routeData) => {
            const isSameData = objDeepCompare(originFormData.value, formData.value);
            if (isSameData) {
                router.push(routeData).catch(() => { });
                return;
            }
            const isConfirmOk = await confirm({
                headerTitle: i18n.t('common.cancel'),
                bodyContent: i18n.t('common.confirm_before_cancel'),
            });
            if (isConfirmOk) {
                router.push(routeData).catch(() => { });
            }
        };
        /**
         * 삭제된 글이면 리턴 시킨다.
         */
        const checkIsDeleted = () => {
            if (itemDetail.value.isDeleted) {
                vuexStore.dispatch(snackbarActionType.showError);
                router.push({
                    name: routeName.MEMBER_COMPANY_INQUIRY,
                });
            }
        };
        /**
         * 초기화
         */
        const initItem = async (_id) => {
            try {
                const response = await pMemberCompanyInquiry.getItem(_id);
                checkIsDeleted();
                pMemberCompanyInquiry.setFormData(response.inquiry);
            }
            catch (error) {
                console.log('memberCompanyInquiry/initItem', error);
                vuexStore.dispatch(snackbarActionType.showError);
            }
        };
        /**
         * 목록 클릭 핸들러
         */
        const handleClickReturnBtn = async () => {
            // 수정페이지면 상세보기, 등록페이지면 목록 페이지로 간다.
            const name = routeName.MEMBER_COMPANY_INQUIRY;
            await checkFormData({
                name,
                query: route.query,
            });
        };
        /**
         * 취소 클릭 핸들러
         */
        const handleClickCancelBtn = async () => {
            // 수정페이지면 상세보기, 등록페이지면 목록 페이지로 간다.
            const name = pageId
                ? routeName.MEMBER_COMPANY_INQUIRY_DETAIL
                : routeName.MEMBER_COMPANY_INQUIRY;
            const params = pageId ? {
                memberCompanyInquiryId: pageId,
            } : {};
            checkFormData({
                name,
                query: route.query,
                params,
            });
        };
        /**
         * 게시물 구분 변경 핸들러
         */
        const handleCategoryChange = () => {
            setFormValue('body', '');
            selectedRadioOption.value = ''; // 선택된 라디오 옵션도 초기화
        };
        /**
         * 선택된 라디오 옵션에 따라 템플릿 데이터를 가져오고 폼 값을 설정합니다.
         */
        const getRadioContent = async () => {
            try {
                if (!templates.value.length) {
                    await pMemberCompanyInquiry.getTempList();
                }
                if (!selectedRadioOption.value) {
                    return;
                }
                // 선택된 라디오 옵션에 해당하는 템플릿 검색
                const selectedTemplate = templates.value.find((template) => template.type === selectedRadioOption.value);
                if (selectedTemplate && selectedTemplate.template) {
                    // 템플릿 데이터 폼에 설정
                    // setFormValue('title', selectedTemplate.template.title || '');
                    setFormValue('body', selectedTemplate.template.body.replace(/\\n/g, '\r\n'));
                }
                else {
                    // 템플릿이 없을 경우 초기화.
                    setFormValue('body', '');
                }
            }
            catch (error) {
                console.log('memberCompanyInquiry/getRadioContent', error);
                vuexStore.dispatch(snackbarActionType.showError, i18n.t('common.unknown_error'));
            }
        };
        const handleRadioChange = async () => {
            if (selectedRadioOption.value === 'PRODUCT') {
                // 템플릿이 없을 경우 초기화.
                setFormValue('body', '');
                return;
            }
            await getRadioContent();
        };
        /**
         * 전송
         */
        const handleSubmitForm = async () => {
            const { valid } = await formRef.value.validate();
            let func = () => { };
            if (!valid) {
                return;
            }
            if (isCreatePage) {
                // formData.processingType 설정
                if (!selectedRadioOption.value) {
                    vuexStore.dispatch(snackbarActionType.showError, i18n.t('common.form_validation_error'));
                    return;
                }
                setFormValue('processingType', selectedRadioOption.value);
            }
            switch (true) {
                case isCreatePage:
                    func = pMemberCompanyInquiry.createItem;
                    break;
                case isEditPage:
                    func = pMemberCompanyInquiry.updateItem;
                    break;
                default: break;
            }
            // api 호출
            try {
                const result = await func();
                vuexStore.dispatch(snackbarActionType.showSuccess, i18n.t('common.success'));
                router.push({
                    name: routeName.MEMBER_COMPANY_INQUIRY_DETAIL,
                    params: {
                        memberCompanyInquiryId: result?.data?.id || pageId,
                    },
                    query: route.query,
                }).catch(() => { });
            }
            catch (error) {
                console.log('error', error);
                vuexStore.dispatch(snackbarActionType.showError);
            }
        };
        /**
         * 페이지 초기화
         */
        onMounted(async () => {
            if (pageId) {
                await initItem(pageId);
            }
        });
        onUnmounted(() => {
            pMemberCompanyInquiry.$reset();
        });
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_select = _resolveComponent("v-select");
            const _component_v_radio = _resolveComponent("v-radio");
            const _component_v_radio_group = _resolveComponent("v-radio-group");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_form = _resolveComponent("v-form");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_form, {
                    class: "cy-form",
                    ref_key: "formRef",
                    ref: formRef,
                    onSubmit: _withModifiers(handleSubmitForm, ["prevent"])
                }, {
                    default: _withCtx(() => [
                        _createVNode(SubController),
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(CardSection, null, {
                                titleContent: _withCtx(() => [
                                    _createCommentVNode(" 제목 "),
                                    _createVNode(InputRow, {
                                        "input-row-class": "",
                                        label: _unref(i18n).t('common.text_title')
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_text_field, {
                                                class: "cy-title",
                                                density: "comfortable",
                                                variant: "outlined",
                                                "hide-details": "auto",
                                                "validate-on": "blur",
                                                rules: _unref(formRule).title,
                                                placeholder: _unref(lc)('placeholder.title'),
                                                "model-value": getFormValue('title'),
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => setFormValue('title', value))
                                            }, null, 8 /* PROPS */, ["rules", "placeholder", "model-value"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["label"])
                                ]),
                                default: _withCtx(() => [
                                    isCreatePage
                                        ? (_openBlock(), _createBlock(InputRow, {
                                            key: 0,
                                            label: _unref(lc)('post_category_title')
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_select, {
                                                    variant: "outlined",
                                                    "hide-details": "auto",
                                                    class: "cy-autocomplete",
                                                    "item-title": "label",
                                                    "item-value": "key",
                                                    density: "compact",
                                                    items: _unref(postFindTypeCategoryItem),
                                                    modelValue: selectedPostCategory.value,
                                                    "onUpdate:modelValue": [
                                                        _cache[1] || (_cache[1] = ($event) => ((selectedPostCategory).value = $event)),
                                                        handleCategoryChange
                                                    ]
                                                }, null, 8 /* PROPS */, ["items", "modelValue"]),
                                                _createElementVNode("div", _hoisted_3, [
                                                    (_openBlock(), _createBlock(_component_v_radio_group, {
                                                        inline: "",
                                                        "hide-details": "",
                                                        class: "cy-target-type-radio",
                                                        density: "compact",
                                                        modelValue: selectedRadioOption.value,
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((selectedRadioOption).value = $event)),
                                                        key: selectedPostCategory.value,
                                                        onChange: handleRadioChange
                                                    }, {
                                                        default: _withCtx(() => [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(radioOptions)[selectedPostCategory.value], (option) => {
                                                                return (_openBlock(), _createBlock(_component_v_radio, {
                                                                    key: option.key,
                                                                    label: option.label,
                                                                    value: option.value
                                                                }, null, 8 /* PROPS */, ["label", "value"]));
                                                            }), 128 /* KEYED_FRAGMENT */))
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["modelValue"]))
                                                ])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["label"]))
                                        : _createCommentVNode("v-if", true),
                                    _createVNode(InputRow, {
                                        label: _unref(lc)('form.body')
                                    }, {
                                        default: _withCtx(() => [
                                            _createCommentVNode(" 본문 "),
                                            _createVNode(_component_v_textarea, {
                                                class: "cy-body wh-pl",
                                                variant: "outlined",
                                                rows: "18",
                                                "row-height": "20",
                                                "hide-details": "auto",
                                                placeholder: _unref(lc)('placeholder.body'),
                                                "validate-on": "blur",
                                                rules: _unref(formRule).body,
                                                "model-value": getFormValue('body'),
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = (value) => setFormValue('body', value))
                                            }, null, 8 /* PROPS */, ["placeholder", "rules", "model-value"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["label"])
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _createCommentVNode(" footer "),
                        _createVNode(BoardFooter, null, {
                            left: _withCtx(() => [
                                _createCommentVNode(" 목록 "),
                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: handleClickReturnBtn }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_icon, null, {
                                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                                                _createTextVNode(" mdi-chevron-left ")
                                            ])),
                                            _: 1 /* STABLE */,
                                            __: [4]
                                        }),
                                        _createTextVNode(" " + _toDisplayString(_unref(i18n).t('common.back_to_list')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })), [
                                    [
                                        _directive_btn_style,
                                        void 0,
                                        "config",
                                        {
                                            info: true,
                                            outlined: true,
                                            "size-l": true,
                                            "width-xs": true
                                        }
                                    ]
                                ])
                            ]),
                            right: _withCtx(() => [
                                _createCommentVNode(" 취소 "),
                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: handleClickCancelBtn }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(i18n).t('common.cancel')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })), [
                                    [
                                        _directive_btn_style,
                                        void 0,
                                        "config",
                                        {
                                            info: true,
                                            outlined: true,
                                            "size-l": true,
                                            "width-xs": true
                                        }
                                    ]
                                ]),
                                _createCommentVNode(" 완료 "),
                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                    type: "submit",
                                    class: "cy-submit-btn"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_icon, { small: "" }, {
                                            default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                _createTextVNode(" mdi-check ")
                                            ])),
                                            _: 1 /* STABLE */,
                                            __: [5]
                                        }),
                                        _createTextVNode(" " + _toDisplayString(submitButtonText.value), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })), [
                                    [
                                        _directive_btn_style,
                                        void 0,
                                        "config",
                                        {
                                            primary: true,
                                            "size-l": true,
                                            "width-xs": true
                                        }
                                    ]
                                ])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }, 512 /* NEED_PATCH */)
            ]));
        };
    }
});
